module.exports = __webpack_public_path__ + "img/chatcaptain.19ad005a.gif";